import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { filter, find, flatten, intersectionWith, orderBy, reduce, sumBy } from 'lodash'
import { getColorRgb, getFilterTypeConstant } from '../../../utils/ResearchTypesUtils'
import ResearchTypes from '../../../utils/ResearchTypes'
import { getPlurial, getPlurialWithNumber, substringNumber } from '../../../utils/StringUtils'
import i18n from 'simple-react-i18n'
import DtoFilterType from '../../../referential/dto/DtoFilterType'
import { connect } from 'react-redux'
import { getDate } from '../../../utils/DateUtil'
import DtoSiteType from '../../../referential/dto/DtoSiteType'
import ThemeDto from '../../../administration/dto/ThemeDto'
import DtoSelectionDetailSite from '../../../sites/dto/DtoSelectionDetailSite'
import DtoSelectionRow from '../../../dashboard/dto/DtoSelectionRow'
import SiteType from '../../../utils/mapUtils/SiteTypes'
import UUID from 'uuid'
import { Avatar, Badge, Chip, CircularProgress, Icon, IconButton, List, ListItem, Tab } from '@material-ui/core'
import DtoCity from '../../../referential/dto/DtoCity'
import DtoWatershed from '../../../referential/dto/DtoWatershed'
import DtoKeyFigures from '../../../sites/dto/DtoKeyFigures'
import { formatNumber } from '../../../utils/NumberUtils'
import DtoSelectionExportHistory from '../../../dashboard/dto/DtoSelectionExportHistory'
import moment from 'moment'
import { appPath } from '../../../conf/basepath'
import { ApplicationUtil } from '../../../utils/ApplicationUtil'
import { ACTION_EXPORT, CATEGORY_EXPORT } from '../../../utils/ApplicationConstants'
import DtoManagementWater from '../../../referential/dto/DtoManagementWater'
import Dialog from '@material-ui/core/Dialog'
import Slide from '@material-ui/core/Slide'
import AppStore from '../../../store/AppStore'
import SelectionAction from '../../../dashboard/actions/SelectionAction'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Tabs from '@material-ui/core/Tabs'
import Typography from '@material-ui/core/Typography'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemText from '@material-ui/core/ListItemText'
import { css } from 'glamor'
import ListSubheader from '@material-ui/core/ListSubheader'
import DtoSimpleStation from '../../../referential/dto/DtoSimpleStation'

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ ref } { ...props } />
})

class SelectionInformationModal extends Component {

	constructor(props) {
		super(props)
		this.state = {
			selectedTabs: 0
		}
	}

	createInformation = (title, information) => {
		return (
			<div key={ UUID.v4() } className='row no-margin'>
				<div className='col s6 no-padding'>
					<b>{ title } : </b>
				</div>
				<div className='col s6 no-padding left-align'>
					{ information }
				</div>
			</div>
		)
	}
	getFilterType = (id) => {
		return find(this.props.filterTypes, (o) => {
			return o.id == id
		})
	}

	getItem = (primaryText, icon, colorRgb, secondaryText = '') => {
		return (
			<ListItem className={ 'col s6 no-padding' }>
				<ListItemAvatar>
					<Avatar { ...css({ backgroundColor: 'transparent !important' }) }>
						<Icon className='material-icons' { ...css({ color: colorRgb }) }>{ icon }</Icon>
					</Avatar>
				</ListItemAvatar>
				<ListItemText primary={ primaryText } secondary={ secondaryText }/>
			</ListItem>
		)
	}

	getCitiesInformations = (data) => {
		return data.map((o) => {
			const ref = find(this.props.cities, (b) => {
				return b.code == o.value
			})
			if (ref) {
				const primaryText = ref.name + ' [' + ref.code + ']'
				const secondaryText = i18n.zip + ' : ' + ref.postalCode
				const icon = 'location_city'
				const color = getColorRgb(ResearchTypes.CITY, true, '0.6')
				return this.getItem(primaryText, icon, color, secondaryText)
			}
			return null
		})
	}
	getWatershedInformatons = (data) => {
		return data.map((o) => {
			const ref = find(this.props.watersheds, (b) => {
				return b.id == o.value
			})
			if (ref) {
				const primaryText = ref.name + ' [' + ref.code + ']'
				const icon = 'texture'
				const color = getColorRgb(ResearchTypes.WATERSHED, true, '0.6')
				return this.getItem(primaryText, icon, color)
			}
			return null
		})
	}
	getManagementWaterInformatons = (data) => {
		return data.map((o) => {
			const ref = find(this.props.managementWaters, (b) => {
				return b.id == o.value
			})
			if (ref) {
				const primaryText = ref.name + ' [' + ref.code + ']'
				const icon = 'texture'
				const color = getColorRgb(ResearchTypes.MANAGEMENT_WATER, true, '0.6')
				return this.getItem(primaryText, icon, color)
			}
			return null
		})
	}

	getStationInformatons = (data) => {
		return data.map((o) => {
			const ref = find(this.props.stations, (b) => {
				return b.id == o.value
			})
			if (ref) {
				const primaryText = ref.name + ' [' + ref.code + ']'
				const icon = 'add_location'
				const color = getColorRgb(ResearchTypes.STATION, true, '0.6')
				return this.getItem(primaryText, icon, color)
			}
			return null
		})
	}
	getRadiusInformations = (data) => {
		return data.map((o) => {
			const jsonObject = JSON.parse(o.value)
			if (jsonObject) {
				const primaryText = Object.keys(jsonObject).map((key) => {
					return (
						<div key={ UUID.v4() } className='row no-margin line-height-1'>
							<h6 className='no-margin'>
								{ i18n[key] }: { substringNumber(jsonObject[key], 2) }
							</h6>
							<br/>
						</div>
					)
				})
				const icon = 'zoom_in'
				const color = getColorRgb(ResearchTypes.RADIUS, true, '0.6')
				return this.getItem(primaryText, icon, color)
			}
			return null
		})
	}

	getListInformations = (data, filterType) => {
		const resultList = (() => {
			switch (filterType.type) {
				case ResearchTypes.CITY.type:
					return this.getCitiesInformations(data)
				case ResearchTypes.RADIUS.type:
					return this.getRadiusInformations(data)
				case ResearchTypes.WATERSHED.type:
					return this.getWatershedInformatons(data)
				case ResearchTypes.STATION.type:
					return this.getStationInformatons(data)
				case ResearchTypes.MANAGEMENT_WATER.type:
					return this.getManagementWaterInformatons(data)
				default:
					return null
			}
		})()
		return (
			<div key={ UUID.v4() } className={ 'col s6 no-padding' }>
				<List className={ 'col s12 no-padding' } subheader={ <li/> }>
					<ListSubheader>{ i18n[filterType.i18n] }</ListSubheader>
					{ resultList }
				</List>
			</div>
		)
	}

	getInformations = (selection) => {
		const listOfFilters = selection.filters
		if (listOfFilters && listOfFilters.length) {
			const reduceFilterTypes = reduce(listOfFilters, (a, b) => {
				if (b.filterTypeId) {
					(a[b.filterTypeId.toString()] || (a[b.filterTypeId.toString()] = [])).push(b)
				}
				return a
			}, {})
			return Object.keys(reduceFilterTypes).map((o) => {
				const filterType = this.getFilterType(o)
				const parameters = getFilterTypeConstant(filterType.filter)
				if (parameters) {
					return this.getListInformations(reduceFilterTypes[o], parameters)
				}
				return null
			})
		}
		return null
	}

	getSum = (idType, type, reduceKeyFigures) => {
		switch (type.type) {
			case SiteType.QUALITOMETER.type:
			case SiteType.QUALITOMETER_SURFACE.type:
				return formatNumber(sumBy(reduceKeyFigures[idType], (o) => {
					return o.nbAnalysis
				}))
			case SiteType.PIEZOMETER.type:
				return formatNumber(sumBy(reduceKeyFigures[idType], (o) => {
					return o.nbMeasure
				}))
			case SiteType.PLUVIOMETER.type:
				return formatNumber(sumBy(reduceKeyFigures[idType], (o) => {
					return o.nbMeasure
				}))
			default:
				return i18n.noData
		}
	}
	getTitleKeyFigures = (type, totalSum) => {
		if (totalSum) {
			switch (type.type) {
				case SiteType.QUALITOMETER.type:
				case SiteType.QUALITOMETER_SURFACE.type:
					return getPlurialWithNumber(i18n.numberAnalysis, i18n.numberAnalysis, totalSum) + ': '
				case SiteType.PIEZOMETER.type:
				case SiteType.PLUVIOMETER.type:
					return getPlurialWithNumber(i18n.numberMeasure, i18n.numberMeasure, totalSum) + ': '
				default:
					return ' '
			}
		}
		return ''
	}

	isUpdate = (idType, reduceKeyFigures, exportHistory) => {
		if (exportHistory.length) {
			return filter(reduceKeyFigures[idType], (a) => {
				return moment(a.endDate) >= moment(exportHistory[0].beginDate)
			})
		}
		return []
	}

	getStations = (selection) => {
		const stations = selection.stations
		const exportHistory = selection.exportHistory
		const reduceStationType = reduce(stations, (a, b) => {
			if (a[b.typeId]) {
				a[b.typeId] = a[b.typeId] + 1
			} else {
				a[b.typeId] = 1
			}
			return a
		}, {})
		const reduceKeyFigures = reduce(selection.keyFigures, (a, b) => {
			(a[b.typeId] || (a[b.typeId] = [])).push(b)
			return a
		}, {})
		const list = orderBy(Object.keys(reduceStationType).map((o) => {
			return {
				id: o,
				nbStation: reduceStationType[o]
			}
		}), ['nbStation'], ['desc'])
		return list.map((o) => {
			const referenceType = SiteType.getType(o.id, this.props.siteTypes)
			const totalSum = this.getSum(o.id, referenceType, reduceKeyFigures)
			const isUpdate = this.isUpdate(o.id, reduceKeyFigures, exportHistory)
			const secondaryTitle = this.getTitleKeyFigures(referenceType, totalSum)
			const leftAvatar = (() => {
				if (isUpdate.length) {
					return (
						<Badge badgeContent={ <Icon className='material-icons' { ...css({ color: 'vert', fontSize: '30px' }) }>error_outline</Icon> }>
							<Avatar className={ 'MuiAvatar-root_selection_informations' } { ...css({ backgroundColor: 'transparent !important' }) } src={ referenceType.icon }/>
						</Badge>
					)
				}
				return (
					<Avatar className={ 'MuiAvatar-root_selection_informations' } { ...css({ backgroundColor: 'transparent !important' }) } src={ referenceType.icon }/>
				)
			})()
			return (
				<ListItem className={ 'col s6 no-padding' }>
					<ListItemAvatar>
						{ leftAvatar }
					</ListItemAvatar>
					<ListItemText primary={ referenceType.title } secondary={ secondaryTitle + '' + totalSum }/>
					<ListItemAvatar>
						<Avatar { ...css({ fontSize: '0.9rem !important' }) }>{ formatNumber(o.nbStation) }</Avatar>
					</ListItemAvatar>
				</ListItem>
			)
		})
	}


	getLastExecution = (exportHistory) => {
		if (exportHistory.length) {
			const lastExport = exportHistory[0]
			return (
				<div className='col s4 no-padding'>
					{ this.createInformation(i18n.lastExport, getDate(lastExport.beginDate)) }
				</div>
			)
		}
		return null
	}

	getExports = (selection) => {
		const exportHistory = selection.exportHistory
		if (exportHistory.length) {
			return exportHistory.map((o) => {
				const beginDate = o.beginDate
				const endDate = o.endDate

				const title = (() => {
					if (o.error) {
						return getDate(beginDate) + ' : ' + i18n.error.errorDuringExport
					} else if (o.filename) {
						return getDate(beginDate) + ' : ' + o.filename
					} else if (o.beginDate && !o.terminated) {
						return getDate(beginDate) + ' : ' + i18n.exportInProgress
					}
					return i18n.error.errorDuringExport
				})()

				const executionTime = (() => {
					if (beginDate && endDate) {
						const diff = moment.duration(moment(endDate).diff(moment(beginDate)))
						if (diff.isValid()) {
							const nbSeconds = diff.get('second')
							return i18n.executionTime + ' : ' + nbSeconds + ' ' + getPlurialWithNumber(i18n.seconde, i18n.secondes, nbSeconds)
						}
						return ''
					}
					return ''
				})()
				const leftAvatar = (() => {
					if (o.error) {
						return (
							<Avatar { ...css({ backgroundColor: 'transparent !important' }) }>
								<Icon className='material-icons' { ...css({ color: 'red', fontSize: '30px' }) }>error</Icon>
							</Avatar>
						)
					} else if (o.filename) {
						return (
							<Avatar { ...css({ backgroundColor: 'transparent !important' }) }>
								<Icon className='material-icons' { ...css({ color: 'green', fontSize: '30px' }) }>done </Icon>
							</Avatar>
						)
					} else if (o.beginDate && !o.terminated) {
						return (
							<Avatar { ...css({ backgroundColor: 'transparent !important' }) }>
								<CircularProgress/>
							</Avatar>
						)
					}
					return (
						<Avatar { ...css({ backgroundColor: 'none' }) }>
							<Icon className='material-icons' { ...css({ color: 'green', fontSize: '30px' }) }>done </Icon>
						</Avatar>
					)
				})()

				const dateDiff = (() => {
					if (beginDate) {
						const diffNow = moment.duration(moment().diff(moment(beginDate)))
						if (diffNow.isValid()) {
							return diffNow.get('days')
						}
						return null
					}
					return null
				})()

				const rightAvatar = (() => {
					if (o.error) {
						return null
					} else if (executionTime && (dateDiff || dateDiff == '0') && dateDiff < 3) {
						return (
							<IconButton onClick={ () => ApplicationUtil.sumbitRegister(CATEGORY_EXPORT, ACTION_EXPORT, o.filename) } href={ appPath + 'exports/' + o.filename }>
								<Icon className='material-icons' { ...css({ color: 'blue', fontSize: '30px' }) }>file_download</Icon>
							</IconButton>
						)
					} else if (o.beginDate && !o.terminated) {
						return null
					}
					return (
						<Chip label={ i18n.expiredDownload }/>
					)
				})()
				return (
					<ListItem className={ 'col s12 no-padding' }>
						<ListItemAvatar>
							{ leftAvatar }
						</ListItemAvatar>
						<ListItemText primary={ title } secondary={ executionTime }/>
						<ListItemAvatar>
							{ rightAvatar }
						</ListItemAvatar>
					</ListItem>
				)
			})
		}
		return null
	}
	handleClose = () => {
		this.setState({ selectedTabs: 0 })
		AppStore.dispatch(SelectionAction.closeModalSelectionInformation())
	}

	a11yProps = (index) => {
		return {
			id: `full-width-tab-${ index }`,
			'aria-controls': `full-width-tabpanel-${ index }`
		}
	}
	changeTabs = (event, newValue) => {
		this.setState({
			selectedTabs: newValue
		})
	}
	getKeyFigures = (selection) => {
		return (
			<div className='row no-margin'>
				<div className='col s12 no-padding'>
					<div className='row no-margin'>
						<div className='col s3 no-padding'>
							{ this.createInformation(i18n.creation, getDate(selection.creationDate)) }
						</div>
						<div className='col s3 no-padding'>
							{ this.createInformation(i18n.update, getDate(selection.updateDate)) }
						</div>
						<div className='col s3 no-padding'>
							{ this.createInformation(i18n.lastExecution, getDate(selection.lastExecutionDate)) }
						</div>
						<div className='col s3 no-padding'>
							{ this.createInformation(i18n.numberExport, selection.exportHistory.length) }
						</div>
						{ this.getLastExecution(selection.exportHistory) }
					</div>
				</div>
			</div>
		)
	}

	getThemes = (selection) => {
		const referencialThemes = flatten(this.props.themes.map(o => o.themes))
		const intersectionSelectionThemes = intersectionWith(referencialThemes, selection.themes, (a, b) => {
			return a.id == b.value
		})
		return intersectionSelectionThemes.map((o) => {
			const masterThemes = find(this.props.themes, (a) => {
				return a.id == o.masterTheme
			})
			return (
				<ListItem className={ 'col s6 no-padding' }>
					<ListItemAvatar>
						<Avatar src={ o.pic }/>
					</ListItemAvatar>
					<ListItemText primary={ o.title } secondary={ masterThemes.title }/>
				</ListItem>
			)
		})
	}

	createTabContent = (index, content) => {
		return (
			<Typography
				key = {index}
				component='div'
				role='tabpanel'
				hidden={ this.state.selectedTabs !== index }
				id={ `scrollable-auto-tabpanel-` + index }
				aria-labelledby={ `scrollable-auto-tab-` + index }
			>
				<div className={ 'row no-margin modalTabInformation' }>
					{ content }
				</div>
			</Typography>
		)
	}

	getTabContents = (selection) => {
		return (
			<div>
				{ this.createTabContent(0, this.getThemes(selection)) }
				{ this.createTabContent(1, this.getInformations(selection)) }
				{ this.createTabContent(2, this.getStations(selection)) }
				{ this.createTabContent(3, this.getExports(selection)) }
			</div>
		)
	}

	getExportTabs = (exportHistory) => {
		if (exportHistory.length) {
			return (
				<Tab key = {'header_3'} label={ getPlurial(i18n.export, i18n.exports, exportHistory) + ' (' + exportHistory.length + ')' } className={ this.a11yProps(3) }/>
			)
		}
		return null
	}

	getTabs = (selection) => {
		return (
			<Tabs
				value={ this.state.selectedTabs }
				onChange={ this.changeTabs }
				indicatorColor='primary'
				textColor='primary'
				variant='fullWidth'
				aria-label='full width tabs example'
			>
				<Tab key = {'header_0'} label={ getPlurial(i18n.theme, i18n.themes, selection.themes) + ' (' + selection.nbTheme + ')' } className={ this.a11yProps(0) }/>
				<Tab key = {'header_1'} label={ getPlurial(i18n.filter, i18n.filters, selection.filters) + ' (' + selection.nbFilter + ')' } className={ this.a11yProps(1) }/>
				<Tab key = {'header_2'} label={ getPlurial(i18n.station, i18n.stations, selection.stations) + ' (' + selection.nbStation + ')' } className={ this.a11yProps(2) }/>
				{ this.getExportTabs(selection.exportHistory) }
			</Tabs>
		)
	}

	getContent = () => {
		if (this.props.selectedSelectionInformation && this.props.modalSelectionInformation) {
			const selection = this.props.selectedSelectionInformation
			return (
				<div>
					<DialogTitle id='alert-dialog-title'>
						<div style={ { 'background-image': `url('${ selection.picture }')` } }
							 className='col s12 modalHeaderPicture no-padding'>
							<div className='header-filter'>
								<div className='row no-margin'>
									<div className='col s12 header-title center-align' style={ { paddingTop: '3rem' } }>
										<h3 className='no-margin white-text'>{ selection.title }</h3>
									</div>
								</div>
								<i className='material-icons white-text clickable font-size-30'
								   onClick={ () => this.close() }
								   style={ { position: 'absolute', right: 0, top: 0 } }>close</i>
							</div>
						</div>
					</DialogTitle>
					<DialogContent>
						{ this.getKeyFigures(selection) }
						{ this.getTabs(selection) }
						{ this.getTabContents(selection) }
					</DialogContent>
				</div>
			)
		}
		return null
	}

	render() {
		return (
			<Dialog
				maxWidth='lg'
				fullWidth={ true }
				TransitionComponent={ Transition }
				modal={ false }
				keepMounted
				open={ this.props.modalSelectionInformation }
				onClose={ this.handleClose }
			>
				{ this.getContent() }
			</Dialog>
		)
	}

}

SelectionInformationModal.propTypes = {
	selectedSelectionInformation: PropTypes.instanceOf(DtoSelectionRow),
	modalSelectionInformation: PropTypes.bool,
	id: PropTypes.string,
	filterTypes: PropTypes.arrayOf(PropTypes.objectOf(DtoFilterType)),
	selectionDetailsSites: PropTypes.arrayOf(PropTypes.objectOf(DtoSelectionDetailSite)),
	siteTypes: PropTypes.arrayOf(PropTypes.objectOf(DtoSiteType)),
	themes: PropTypes.arrayOf(PropTypes.objectOf(ThemeDto)),
	cities: PropTypes.arrayOf(PropTypes.objectOf(DtoCity)),
	stations: PropTypes.arrayOf(PropTypes.objectOf(DtoSimpleStation)),
	watersheds: PropTypes.arrayOf(PropTypes.objectOf(DtoWatershed)),
	managementWaters: PropTypes.arrayOf(PropTypes.objectOf(DtoManagementWater)),
	selectionKeyFigures: PropTypes.arrayOf(PropTypes.objectOf(DtoKeyFigures)),
	selectionExportsHistory: PropTypes.arrayOf(PropTypes.objectOf(DtoSelectionExportHistory))
}

const mapStateToProps = store => {
	return {
		selectedSelectionInformation: store.SelectionReducer.selectedSelectionInformation,
		modalSelectionInformation: store.SelectionReducer.modalSelectionInformation,
		filterTypes: store.ReferentialReducer.filterTypes,
		siteTypes: store.ReferentialReducer.siteTypes,
		cities: store.ReferentialReducer.cities,
		stations: store.ReferentialReducer.stations,
		watersheds: store.ReferentialReducer.watersheds,
		managementWaters: store.ReferentialReducer.managementWaters,
		selectionDetailsSites: store.SelectionReducer.selectionDetailsSites,
		themes: store.AdministrationReducer.themes,
		selectionKeyFigures: store.SelectionReducer.selectionKeyFigures,
		selectionExportsHistory: store.SelectionReducer.selectionExportsHistory
	}
}

export default connect(mapStateToProps)(SelectionInformationModal)



// WEBPACK FOOTER //
// ./src/components/modal/selection/SelectionInformationModal.js